import TAnnouncementsDetail from './index.vue';

TAnnouncementsDetail.install = app => {
  app.component(TAnnouncementsDetail.name, TAnnouncementsDetail);
};

export default TAnnouncementsDetail;
